import { cloneDeep } from 'lodash';
import * as React from 'react';
import * as S from './styles';
import { IProps } from './types';

const WidgetCall: React.FC<IProps> = (props) => {
    const divRef = React.useRef() as any;

    function GetPureHtml(widgetCall: string|undefined): string {
        if (!widgetCall) return "";
        let pureHtml = "";
        let html = cloneDeep(widgetCall);
        while(html?.indexOf("<script")!=-1) {
            pureHtml += html?.substring(0,html?.indexOf("<script")-1);
            if (html.indexOf("</script>") != -1) {
                html = html.substring(html.indexOf("</script>")+9);
            }
        }
        pureHtml += html;
        return pureHtml;
    }

    function GetScriptSRCs(widgetCall: string|undefined): string[] {
        if (!widgetCall) return [];
        let scriptSRCs: string[] = [];
        let html = cloneDeep(widgetCall);
        while(html.indexOf("http")!=-1 && html.indexOf(".js")!=-1) {
            scriptSRCs.push(html.substring(html.indexOf("http"), html.indexOf(".js")+3));
            html = html.substring(html.indexOf(".js")+3);
        }
        return scriptSRCs;
    }

    const htmlPure = GetPureHtml(props.widgetCall); 
    const scriptSrc = GetScriptSRCs(props.widgetCall); 

    React.useEffect(() => {
        if (divRef.current) {
            for(let i=0;i<scriptSrc.length;i++) {
                const scriptId = "widgetScript" + "_" + props.widgetIndex.toString() + "_" + i;
                const scriptElement = document.getElementById(scriptId);
                if (scriptElement) {
                    document.head.removeChild(scriptElement);
                }
                const script = document.createElement('script');
                script.id = scriptId;
                script.src = scriptSrc[i].replace(".js","CONF.js") + "?v=" + (Math.floor(Math.random() * 1000)).toString();
                document.head.appendChild(script);
            }
            return () => {
                for(let i=0;i<scriptSrc.length;i++) {
                    const scriptIdToRemove = "widgetScript" + "_" + props.widgetIndex.toString() + "_" + i;
                    const script = document.getElementById(scriptIdToRemove);
                    if (script) document.head.removeChild(script);
                }
            }
    }
    }, []);

    return (
        <div ref={divRef} dangerouslySetInnerHTML={{__html: htmlPure}}>
        </div>
    )
}

export default WidgetCall;
